import { useState, useEffect } from 'react'
import { client } from '../sanity/client'

export function useSiteSettings() {
  const [settings, setSettings] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    console.log('Fetching site settings...')
    client
      .fetch(`*[_type == "siteSettings"][0] {
        introText,
        contextText,
        portfolioUrl,
        timelineDescription,
        email,
        linkedinUrl,
        showAndTellUrl
      }`)
      .then(data => {
        console.log('Site settings received:', data)
        setSettings(data)
        setLoading(false)
      })
      .catch(err => {
        console.error('Error fetching site settings:', err)
        setLoading(false)
      })
  }, [])

  return { settings, loading }
}
